export default "/images/793395342705b6f969ad8f9dc4b07941.avif";